import {Card, CardContent, Typography, Box, Divider, Chip} from '@mui/material';

interface LlmResponseActionProps {
    actionValue: any[];
    action: string;
    actionIndex?: number;
    result?: any;
    projectStatus?: string; 
}

const LlmResponseAction: React.FC<LlmResponseActionProps> = ({
  actionValue,
}) => {
  if (!actionValue?.length) {
    return (
      <Typography variant="body2" color="textSecondary">
        No LLM response data available.
      </Typography>
    );
  }

  return (
    <Box className="space-y-4">
      {actionValue.map((item, index) => (
        <Card
          key={index}
          variant="outlined"
          className="rounded-2xl shadow-sm border border-gray-200"
        >
          <CardContent className="space-y-3">
            {/* Prompt */}
            {item.prompt && (
              <>
                <Typography variant="subtitle2" color="textSecondary">
                  Prompt:
                </Typography>
                <Typography
                  variant="body1"
                  className="font-medium text-gray-900"
                >
                  {item.prompt}
                </Typography>
                <Divider className="my-2" />
              </>
            )}

            {/* Outputs */}
            {item.outputs?.length ? (
              item.outputs.map((output: any, i: number) => (
                <Box
                  key={i}
                  className="bg-gray-50 p-3 rounded-xl space-y-2 border border-gray-100"
                >
                  <Box className="flex items-center justify-between">
                    <Chip
                      label={output.llm_platform || "Unknown Platform"}
                      color="primary"
                      size="small"
                      variant="outlined"
                    />
                    {output.is_editable && (
                      <Chip
                        label="Editable"
                        size="small"
                        color="success"
                        variant="outlined"
                      />
                    )}
                  </Box>

                  {output.title && (
                    <Typography
                      variant="subtitle2"
                      className="font-semibold text-gray-800"
                    >
                      {output.title}
                    </Typography>
                  )}

                  <Typography
                    variant="body2"
                    color="textSecondary"
                    className="whitespace-pre-wrap"
                  >
                    {output.generated_content}
                  </Typography>

                  {output.edited_response && (
                    <Box className="bg-white p-2 rounded-lg border border-green-100">
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        className="font-semibold text-green-600"
                      >
                        Edited Response:
                      </Typography>
                      <Typography
                        variant="body2"
                        className="whitespace-pre-wrap text-gray-800"
                      >
                        {output.edited_response}
                      </Typography>
                    </Box>
                  )}
                </Box>
              ))
            ) : (
              <Typography variant="body2" color="textSecondary">
                No outputs found.
              </Typography>
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default LlmResponseAction;